var app = angular.module('leonardo');

var AdminClientInstanceListController = function ($scope, $rootScope, $element, FilterService, NotificationService) {
  $scope.$on('filter-selection:updated', function () {
    const { search } = FilterService.filters;
    window.oldReduxStore.dispatch(window.oldReduxActions.setWhiteLabelFilters({ name: search }));
  });

  $scope.$on('filter-service:filter-removed', function (event, key) {
    if (key === 'search') {
      window.oldReduxStore.dispatch(window.oldReduxActions.resetWhiteLabelFilters());
    }
  });

  $scope.reactSubmissionCallbackError = function (callback) {
    if (callback && callback.response && callback.response.data) {
      NotificationService.error(callback.response.data);
    }
  };

  $rootScope.loadReact({
    selector: '#white-label-list',
    $element,
    component: window.oldReactComponent.WhiteLabel.ListPage,
    data: {
      reactSubmissionCallbackError: $scope.reactSubmissionCallbackError
    }
  });

  $scope.$on('$destroy', function () {
    window.oldReduxStore.dispatch(window.oldReduxActions.resetWhiteLabelFilters());
  });
};

app.controller('AdminClientInstanceListController', ['$scope', '$rootScope', '$element', 'FilterService', 'NotificationService', AdminClientInstanceListController]);
